var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-geo-box',[_c('b-checkbox',{staticClass:"content",model:{value:(_vm.isTotalUsa),callback:function ($$v) {_vm.isTotalUsa=$$v},expression:"isTotalUsa"}},[_vm._v("Total USA")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c77eba7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/GeoTotalUsa.vue
// module id = null
// module chunks = 